"use client";

import { usePathname } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import { PiList } from "react-icons/pi";

import { BREAKPOINT_LG } from "@/configs/breakpoints.config";
import { useBreakpoint } from "@/hooks/use-breakpoint";
import { DEFAULT_LOCALE, getLocaleFromPathname } from "@/lib/i18n/locales";
import { cn } from "@/lib/utils";

import { Button } from "../button/button";
import NavigationLink, { getNavigationLinks } from "./navigation-link";

export default function NavigationMobile() {
  const [navOpen, setNavOpen] = useState(false);
  const pathname = usePathname();
  const isLG = useBreakpoint(BREAKPOINT_LG);
  const locale = pathname ? getLocaleFromPathname(pathname) : DEFAULT_LOCALE;
  const navigationLinks = getNavigationLinks(locale);

  const handleNavigation = useCallback(
    (open: boolean) => {
      setNavOpen(open);

      if (open && !isLG) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    [setNavOpen, isLG]
  );

  useEffect(() => {
    handleNavigation(false);
  }, [pathname, isLG, handleNavigation]);

  return (
    <>
      <Button
        variant="ghost"
        className="lg:hidden group h-[var(--navbar-height)] min-w-[var(--sidebar-width-small)] p-0 rounded-none border-0 hover:bg-primary-100"
        onClick={() => handleNavigation(!navOpen)}
      >
        <PiList className="w-7 h-7 text-white group-hover:text-black" />
      </Button>
      <div
        className={cn(
          "lg:hidden fixed w-72 h-full top-[var(--navbar-height)] left-0 bg-neutral-400 flex flex-col items-start p-4 gap-y-8 border-r-2 border-black -translate-x-72 transition-all duration-300 overflow-hidden z-50",
          navOpen && "translate-x-0"
        )}
      >
        {navigationLinks.map(navlink => (
          <NavigationLink key={navlink.title} {...navlink} />
        ))}
      </div>
      {navOpen && !isLG && (
        <div
          className="fixed top-[var(--navbar-height)] left-0 w-full h-full bg-black opacity-50 z-40"
          onClick={() => handleNavigation(false)}
        />
      )}
    </>
  );
}
